import loanWriteOff from "@/api/credit-operation/loan-write-off";

import { baseState, baseMutations } from "@/store/mixins";

export const state = {
    ...baseState,
    loanDisbursements: [],
    writeOffTypes: []
};

export const getters = {};

export const mutations = {
    ...baseMutations,
    SET_LAON_DISBURSEMENTS(state, data) {
        state.loanDisbursements = data;
    },
    SET_WRITE_OFF_TYPES(state, data) {
        state.writeOffTypes = data;
    },
    CLEAR_RESOURCES(state) {
        state.loanDisbursements = [];
        state.writeOffTypes = [];
    }
};

export const actions = {
    fetch(context, attrubutes = {}) {
        let params = Object.assign(
            {
                page: context.state.pagination.page,
                perPage: context.state.pagination.perPage,
                filter: {
                    search: context.state.search
                }
            },
            attrubutes
        );
        return loanWriteOff.get({ params }).then(response => {
            context.commit("RECEIVE_RESOURCES", response);
            return Promise.resolve(response);
        });
    },
    store(context, data) {
        return loanWriteOff.store(data);
    },
    update(context, { id, data }) {
        return loanWriteOff.update(id, data);
    },
    async getLoanDisbursement(context, attributes = {}) {
        const params = Object.assign(
            {
                page: context.state.pagination.page,
                perPage: context.state.pagination.perPage,
                filter: {
                    search: attributes.search,
                    approve_status: 2, //Approved
                    is_finished: false,
                    is_write_off: false,
                }
            },
            attributes
        );
        let response = await loanWriteOff.loanDisbursement({ params });
        context.commit("SET_LAON_DISBURSEMENTS", response.data);
    },
    async getWriteOffType(context, attributes = {}) {
        let response = await loanWriteOff.writeOffType({ params: attributes });
        context.commit("SET_WRITE_OFF_TYPES", response.data);
    },
};
